import { useState } from "react";
import { Pencil, X } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AuthImage } from "@/components/damages/AuthImage";
import { fmtEur, fmtDate } from "@/lib/format";

const Row = ({ label, children, testId }) => (
  <div className="flex flex-col gap-0.5 sm:flex-row sm:gap-4">
    <dt className="w-40 shrink-0 text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</dt>
    <dd className="text-sm text-slate-900" data-testid={testId}>{children || <span className="text-slate-400">—</span>}</dd>
  </div>
);

export const DamageView = ({ damage, onClose, onEdit }) => {
  const [zoom, setZoom] = useState(null);
  const d = damage;
  return (
    <Dialog open={!!d} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[92vh] max-w-2xl overflow-y-auto" data-testid="damage-view-dialog">
        {d && <>
          <DialogHeader>
            <DialogTitle className="flex flex-wrap items-center gap-2">
              Sinistro <span className="font-mono-num rounded-md border border-slate-300 bg-slate-50 px-2 py-0.5 text-sm">{d.plate}</span>
              <span className={`rounded-full border px-2.5 py-0.5 text-xs font-semibold ${d.status === "CHIUSA" ? "border-slate-200 bg-slate-100 text-slate-600" : "border-amber-200 bg-amber-50 text-amber-700"}`}>{d.status === "CHIUSA" ? "Chiusa" : "Aperta"}</span>
            </DialogTitle>
            <DialogDescription>{d.model} · {d.station_name} · {fmtDate(d.incident_date)}</DialogDescription>
          </DialogHeader>
          <div className="rounded-lg border border-rose-200 bg-rose-50 px-4 py-3">
            <p className="text-xs font-semibold uppercase tracking-wider text-rose-700">Franchigia</p>
            <p className="font-mono-num text-2xl font-semibold text-slate-900" data-testid="damage-view-franchise">{d.franchise_amount == null ? "da inserire" : fmtEur(d.franchise_amount)}</p>
          </div>
          <dl className="space-y-3">
            <Row label="Driver" testId="damage-view-driver">{d.driver_name}</Row>
            <Row label="Descrizione" testId="damage-view-description"><span className="whitespace-pre-wrap">{d.description}</span></Row>
          </dl>
          <div>
            <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-slate-500">Foto ({d.photos.length})</p>
            {d.photos.length ? (
              <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
                {d.photos.map((p) => <AuthImage key={p.id} photoId={p.id} className="h-32 w-full cursor-zoom-in rounded-lg" onClick={() => setZoom(p.id)} testId={`damage-view-photo-${p.id}`} />)}
              </div>
            ) : <p className="text-sm text-slate-400">Nessuna foto caricata.</p>}
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={onClose} data-testid="damage-view-close">Chiudi</Button>
            <Button onClick={() => onEdit(d)} data-testid="damage-view-edit"><Pencil className="mr-2 h-4 w-4" /> Modifica</Button>
          </DialogFooter>
          {zoom && (
            <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/85 p-4" onClick={() => setZoom(null)} data-testid="damage-view-zoom">
              <button className="absolute right-4 top-4 rounded-full bg-white/90 p-2" onClick={() => setZoom(null)}><X className="h-5 w-5" /></button>
              <AuthImage photoId={zoom} className="max-h-[90vh] max-w-full rounded-lg object-contain" />
            </div>
          )}
        </>}
      </DialogContent>
    </Dialog>
  );
};
